import React from 'react';

class HoverPanel extends React.Component {
    constructor(){
        super();
        this.state = {
            scrolled: false
        };
        // this.scrollCheck = this.scrollCheck.bind(this);
        this.flipPanel = this.flipPanel.bind(this);
    }
    componentWillMount(){
        // document.addEventListener("scroll", _.debounce(() => {this.scrollCheck()}, 200));
    }
    componentWillUnmount(){
        // document.removeEventListener("scroll", () => _.debounce(() => {this.scrollCheck()}, 200));
    }
    componentWillReceiveProps(nextProps){
        if(this.props.text !== nextProps){
            this.setState({
                scrolled: false
            });
        }
    }
    // scrollCheck(){
    //     if(this.refs.flipPanel){
    //         if($(this.refs.flipPanel).offset().top - $(this.refs.flipPanel).height() / 2 < $(document).scrollTop() && !this.state.scrolled){
    //             this.setState({
    //                 scrolled: true
    //             });
    //         }if($(this.refs.flipPanel).offset().top - $(window).height() > $(document).scrollTop() && this.state.scrolled){
    //             this.setState({
    //                 scrolled: false
    //             });
    //         }
    //     }
    // }
    flipPanel(){
        this.setState({
            scrolled: !this.state.scrolled
        });
    }
    formatTitle(){
        let fst = this.props.title.split(" ")[0],
            scnd = this.props.title.split(" ")[1];

        if(fst) fst = fst.toLowerCase().replace(/i/g, "/");
        if(scnd) scnd = scnd.toLowerCase().replace(/i/g, "/");

        return <div>
            <p>{fst}</p>
            <p>{scnd}</p>
        </div>;
    }
    render(){
        return (
            <div className={this.state.scrolled ? "flip-content flip" : "flip-content" } ref="flipPanel" onClick={this.flipPanel}>
                <div className="front">
                    <div className="text">
                        {this.formatTitle()}
                    </div>
                </div>
                <div className="back">
                    <p>{this.props.text}</p>
                </div>
            </div>
        );
    }
}

export default HoverPanel;


/** WEBPACK FOOTER **
 ** ./src/js/components/parts/hoverPanel.js
 **/